import { FunctionComponent, useEffect, useState } from "react";
import { NavLink } from "react-router";

import { Breadcrumbs, Typography } from "@digital-services/ui";
import { IBreadcrumbs } from "@digital-services/ui/types";

// very similar to IBreadcrumbs['breadcrumbs']
export interface BreadCrumbItem {
  name: string;
  url?: string;
}

interface Props {
  breadCrumbs: BreadCrumbItem[];
}

const getClasses = (breadcrumbsLength: number) => {
  let classes = "flex h-8 [&>nav]:mt-auto min-w-[403px] medium-screen:order-3";

  if (breadcrumbsLength < 3) {
    classes +=
      " [&>nav>ol>li:last-child>div]:w-full [&>nav>ol>li:last-child]:w-full [&>nav>ol>li:last-child]:truncate [&>nav>ol]:w-full [&>nav]:w-full";
  }

  return classes;
};

export const CustomBreadCrumb: FunctionComponent<Props> = ({ breadCrumbs }) => {
  const typographyWrapper = (id: string, content: string, href?: string) => {
    return (
      <NavLink
        to={href ?? ""}
        className={({ isActive }) =>
          isActive ? "truncate font-bold [&>p]:truncate" : "whitespace-nowrap"
        }
        end
        data-testid={id}
      >
        <Typography variant="smallText">{content}</Typography>
      </NavLink>
    );
  };
  const [breadcrumb, setBreadcrumb] = useState<IBreadcrumbs>({
    breadcrumbs: []
  });

  useEffect(() => {
    const newBreadCrumb: IBreadcrumbs = { breadcrumbs: [] };
    let index = 0;
    for (const bCrumb of breadCrumbs) {
      const id = `breadCrumb_${index.toString()}`;
      newBreadCrumb.breadcrumbs.push({
        id: id,
        content: typographyWrapper(id, bCrumb.name, bCrumb.url)
      });
      index++;
    }
    setBreadcrumb(newBreadCrumb);
  }, [breadCrumbs]);

  return (
    <div
      className={getClasses(breadCrumbs.length)}
      data-testid="breadcrumbs-main-container"
    >
      <Breadcrumbs breadcrumbs={breadcrumb?.breadcrumbs} />
    </div>
  );
};
